import styled from "styled-components"
import { Col, Row } from "reactstrap"

export const CarrierDeliveryCodeInputRow = styled(Row)`
  margin-top: 5px;
`

export const CarrierDeliveryCodeInputCol = styled(Col)`
  display: flex;
  align-items: center;
`

export const CarrierDeliveryCodeExplaining = styled.p`
  color: #c1c1c1;
  font-size: 10px;
  margin-top: 10px !important;
`
